export const permissions = {
  admin: {
    viewGlobalInbox: true,
    viewMetrics: true,
    viewBilling: true,
    viewTechnicalData: true,
    viewSalesData: true,
    takeConversation: true,
    transferConversation: true,
    closeConversation: true,
    reopenConversation: true,
    toggleIA: true,
    assignConversation: true,
    generatePaymentLink: true,
    viewInvoice: true,
    viewPaymentHistory: true,
    viewBCM: true,
    scheduleVisit: true,
    closeSale: true,
    configureSystem: true,
    manageUsers: true,
  },

  supervisor: {
    viewGlobalInbox: true,
    viewMetrics: true,
    viewBilling: true,
    viewTechnicalData: true,
    viewSalesData: true,
    takeConversation: true,
    transferConversation: true,
    closeConversation: true,
    reopenConversation: true,
    toggleIA: true,
    assignConversation: true,
    generatePaymentLink: true,
    viewInvoice: true,
    viewPaymentHistory: true,
    viewBCM: true,
    scheduleVisit: true,
    closeSale: true,
    configureSystem: false,
    manageUsers: false,
  },

  agente: {
    viewGlobalInbox: false,
    viewMetrics: false,
    viewBilling: true,
    viewTechnicalData: true,
    viewSalesData: true,
    takeConversation: true,
    transferConversation: true,
    closeConversation: true,
    reopenConversation: false,
    toggleIA: false,
    assignConversation: false,
    generatePaymentLink: true,
    viewInvoice: true,
    viewPaymentHistory: true,
    viewBCM: true,
    scheduleVisit: true,
    closeSale: true,
    configureSystem: false,
    manageUsers: false,
  },

  atencion: {
    viewGlobalInbox: false,
    viewMetrics: false,
    viewBilling: true,
    viewTechnicalData: false,
    viewSalesData: false,
    takeConversation: true,
    transferConversation: true,
    closeConversation: true,
    reopenConversation: false,
    toggleIA: false,
    assignConversation: false,
    generatePaymentLink: true,
    viewInvoice: true,
    viewPaymentHistory: true,
    viewBCM: false,
    scheduleVisit: false,
    closeSale: false,
    configureSystem: false,
    manageUsers: false,
  },

  soporte: {
    viewGlobalInbox: false,
    viewMetrics: false,
    viewBilling: false,
    viewTechnicalData: true,
    viewSalesData: false,
    takeConversation: true,
    transferConversation: true,
    closeConversation: true,
    reopenConversation: false,
    toggleIA: false,
    assignConversation: false,
    generatePaymentLink: false,
    viewInvoice: false,
    viewPaymentHistory: false,
    viewBCM: true,
    scheduleVisit: true,
    closeSale: false,
    configureSystem: false,
    manageUsers: false,
  },

  ventas: {
    viewGlobalInbox: false,
    viewMetrics: false,
    viewBilling: false,
    viewTechnicalData: false,
    viewSalesData: true,
    takeConversation: true,
    transferConversation: true,
    closeConversation: true,
    reopenConversation: false,
    toggleIA: false,
    assignConversation: false,
    generatePaymentLink: false,
    viewInvoice: false,
    viewPaymentHistory: false,
    viewBCM: false,
    scheduleVisit: false,
    closeSale: true,
    configureSystem: false,
    manageUsers: false,
  },
};